var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/DesktopMenu.js",
  _this = this;
import React from 'react';
import Grid from '../Grid';
import Row from '../Row';
import Column from '../Column';
import Text from '../Text';
import { withTheme } from '../../core/ThemeProvider';
import styled, { css } from 'styled-components';
import { remCalc } from '@lux/helpers';
import { noop } from '../../helpers';
var StyledListItem = styled.li.withConfig({
  displayName: "DesktopMenu__StyledListItem",
  componentId: "sc-1q34iig-0"
})(["margin:0;padding:0;"]);
var StyledListItemText = withTheme(styled(Text).withConfig({
  displayName: "DesktopMenu__StyledListItemText",
  componentId: "sc-1q34iig-1"
})(function (props) {
  return css(["display:block;color:", ";font-size:", ";font-family:", ";"], props.coreTheme.cl_black, props.coreTheme.fs_sm, props.secondary ? props.coreTheme.ff_sec_thin : props.coreTheme.ff_sec_bold);
}));
var DesktopPrimaryMenuItems = withTheme(styled(Text).withConfig({
  displayName: "DesktopMenu__DesktopPrimaryMenuItems",
  componentId: "sc-1q34iig-2"
})(function (props) {
  return css(["line-height:", ";padding:0 0 0 ", ";font-size:", ";color:", ";"], remCalc(64), remCalc(20), props.coreTheme.header.desktopMenuFontSize, props.active ? props.coreTheme.header.desktopMenuActiveFontColor : props.coreTheme.header.desktopMenuInActiveFontColor);
})); // TODO: Standardise DropDown

var DeskTopSubMenuItems = withTheme(styled.ul.withConfig({
  displayName: "DesktopMenu__DeskTopSubMenuItems",
  componentId: "sc-1q34iig-3"
})(function (props) {
  return css(["display:block;list-style-type:none;position:absolute;visibility:hidden;width:", ";border-radius:", ";background-color:", ";padding:0;margin-left:", ";margin-top:", ";box-shadow:", ";z-index:999;&::after{content:'';position:absolute;bottom:100%;left:50%;margin-left:", ";border-width:", ";border-style:solid;border-color:transparent transparent ", " transparent;}", ":hover &{visibility:visible;}"], remCalc(150), remCalc(8), props.coreTheme.cl_white, remCalc(-10), remCalc(-10), props.coreTheme.sd_size_1, remCalc(-10), remCalc(7), props.coreTheme.cl_white, StyledListItem);
}));
var DesktopSubMenuListItemAnchor = withTheme(styled(Text).withConfig({
  displayName: "DesktopMenu__DesktopSubMenuListItemAnchor",
  componentId: "sc-1q34iig-4"
})(function (props) {
  return css(["display:block;padding:", " ", ";font-size:", ";color:", ";&:not([disabled]):hover{color:", ";}"], remCalc(9), remCalc(20), props.coreTheme.header.desktopSubMenuFontSize, props.coreTheme.header.desktopSubMenuFontColor, props.coreTheme.header.desktopSubMenuActiveFontColor);
}));
var SecondaryDesktop = withTheme(styled.div.withConfig({
  displayName: "DesktopMenu__SecondaryDesktop",
  componentId: "sc-1q34iig-5"
})(function (props) {
  return css(["width:100%;background-color:", ";box-shadow:1px 2px 10px 1px ", ";position:absolute;left:0;right:0;margin:0 auto;z-index:99999;"], props.coreTheme.cl_white, props.coreTheme.cl_ter_l4);
}));
var SecondaryDesktopMenuColumn = withTheme(styled(Column).withConfig({
  displayName: "DesktopMenu__SecondaryDesktopMenuColumn",
  componentId: "sc-1q34iig-6"
})(function (props) {
  return css(["padding:", ";padding-left:", ";border-right:1px solid ", ";"], remCalc(30), props.index === 0 ? remCalc(10) : remCalc(30), props.coreTheme.cl_ter_l5);
}));
var ThirdDesktopMenuList = styled.ul.withConfig({
  displayName: "DesktopMenu__ThirdDesktopMenuList",
  componentId: "sc-1q34iig-7"
})(["display:flex;flex-direction:column;list-style-type:none;text-align:left;padding:0;margin:0;"]);
var DesktopMenu = function DesktopMenu(_ref) {
  var baseUrl = _ref.baseUrl,
    menuItems = _ref.menuItems,
    hasMenuIcons = _ref.hasMenuIcons,
    menuHoverKey = _ref.menuHoverKey,
    onMenuMouseEnter = _ref.onMenuMouseEnter,
    onMenuMouseLeave = _ref.onMenuMouseLeave,
    _ref$onMenuItemClick = _ref.onMenuItemClick,
    onMenuItemClick = _ref$onMenuItemClick === void 0 ? noop : _ref$onMenuItemClick;
  return menuItems.map(function (menuItem, key) {
    var showSecondaryMenu = menuHoverKey === key && menuItem.subMenu && menuItem.subMenu.length > 0;
    return /*#__PURE__*/React.createElement(StyledListItem, {
      key: key,
      onMouseEnter: function onMouseEnter() {
        return onMenuMouseEnter(key);
      },
      onMouseLeave: function onMouseLeave() {
        return onMenuMouseLeave(key);
      },
      "data-testid": "desktop-menu-hover-".concat(key + 1),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 142,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(DesktopPrimaryMenuItems, {
      type: "link",
      href: "".concat(baseUrl).concat(menuItem.item.href),
      active: menuItem.item.active,
      onClick: function onClick(e) {
        onMenuItemClick(e, menuItem.item);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 149,
        columnNumber: 9
      }
    }, menuItem.item.title), !hasMenuIcons && menuItem.subMenu && menuItem.subMenu.map(function (subMenu, key) {
      return /*#__PURE__*/React.createElement(DeskTopSubMenuItems, {
        key: key,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(StyledListItem, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(DesktopSubMenuListItemAnchor, {
        type: "link",
        href: "".concat(baseUrl).concat(subMenu.item.href),
        onClick: subMenu.item.onClick,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 167,
          columnNumber: 17
        }
      }, subMenu.item.title)));
    }), hasMenuIcons && showSecondaryMenu && /*#__PURE__*/React.createElement(SecondaryDesktop, {
      "data-testid": "secondary-desktop-menu",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 179,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 180,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Row, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 181,
        columnNumber: 15
      }
    }, menuItem.subMenu && menuItem.subMenu.map(function (subMenuItem, key) {
      return /*#__PURE__*/React.createElement(SecondaryDesktopMenuColumn, {
        sm: true,
        key: key,
        index: key,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 186,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(StyledListItemText, {
        type: "link",
        href: "".concat(baseUrl).concat(subMenuItem.item.href),
        onClick: function onClick(e) {
          onMenuItemClick(e, subMenuItem.item);
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 187,
          columnNumber: 25
        }
      }, subMenuItem.item.title), /*#__PURE__*/React.createElement(ThirdDesktopMenuList, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 197,
          columnNumber: 25
        }
      }, subMenuItem.subMenu && subMenuItem.subMenu.map(function (subSubMenuItem, key) {
        return /*#__PURE__*/React.createElement(StyledListItem, {
          key: key,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 202,
            columnNumber: 33
          }
        }, /*#__PURE__*/React.createElement(StyledListItemText, {
          type: "link",
          href: "".concat(baseUrl).concat(subSubMenuItem.item.href),
          secondary: true,
          onClick: function onClick(e) {
            onMenuItemClick(e, subSubMenuItem.item);
          },
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 203,
            columnNumber: 35
          }
        }, subSubMenuItem.item.title));
      })));
    })))));
  });
};
export default DesktopMenu;